module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_02_1280_1280_zh-hant-919699a4aa5e54bca08eabd8e603792c.jpg";